import { ThemeProvider, CssBaseline } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { useContext } from "react";
import { ExtraDataContext } from "../../Context/ExtraDataContext";
import './Theme.scss';

const light = {
    palette: {
        type: "light",
    },
};
const dark = {
    palette: {
        type: "dark",
    },
};

const MainThemeChange = ({ children }) => {
    const { isDarkTheme } = useContext(ExtraDataContext);
    const getCurrentTheme = localStorage.getItem('darkTheme');
    const getMainBody = document.getElementById('mainBody');

    if (getCurrentTheme === 'true') {
        getMainBody.style.backgroundColor = "#121212";
        getMainBody.style.color = "hsl(0, 0%, 85%)";
        getMainBody.classList.add("mainHeadingColorDark");
    }
    if (getCurrentTheme === 'false') {
        getMainBody.style.backgroundColor = "#F7F9FD";
        getMainBody.style.color = "rgb(19, 17, 17)";
        getMainBody.classList.remove("mainHeadingColorDark");
    }
    return (
        <ThemeProvider theme={isDarkTheme ? createTheme(dark) : createTheme(light)}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default MainThemeChange;